/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface WorkflowUpdateRequest {
  name?: string;
  note?: string | null;
  context?: object | null;
  _default?: boolean;
  disabled?: boolean;
  contextSchema?: object | null;
}

export function WorkflowUpdateRequestFromJSON(
  json: any,
): WorkflowUpdateRequest {
  return WorkflowUpdateRequestFromJSONTyped(json);
}

export function WorkflowUpdateRequestFromJSONTyped(
  json: any,
): WorkflowUpdateRequest {
  if (json == null) {
    return json;
  }

  return {
    name: json["name"],
    note: json["note"],
    context: json["context"],
    _default: json["default"],
    disabled: json["disabled"],
    contextSchema: json["context_schema"],
  };
}

export function WorkflowUpdateRequestToJSON(
  value: WorkflowUpdateRequest | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value.name,
    note: value.note,
    context: value.context,
    default: value._default,
    disabled: value.disabled,
    context_schema: value.contextSchema,
  };
}
